import { useState } from 'preact/hooks';
import { DocIcon } from './Icons.jsx';

const TOPICS = ['Billing', "Something's broken", 'Setup help'];

/**
 * First contact. The store URL is prefilled from the app session, and the
 * topic rides along as conversation metadata so the thread routes to the right
 * agent. Suggested articles sit underneath — a merchant who self-serves here
 * never becomes a conversation, which is what the docs deflection number in
 * the dashboard is counting.
 */
export function PreChat({ welcome, shop, docs, onStart, onOpenDoc, sending }) {
  const [topic, setTopic] = useState(TOPICS[1]);
  const [message, setMessage] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const body = message.trim();
    if (!body) return;
    onStart({ topic, body, shop });
  };

  return (
    <form class="form" onSubmit={submit}>
      <div>
        <div class="form__lede">Hi there 👋</div>
        <div class="form__sub">{welcome}</div>
      </div>

      <div class="form__fields">
        {shop && (
          <div>
            <div class="field__label">STORE URL</div>
            <div class="field__input field__input--readonly">{shop}</div>
          </div>
        )}

        <div>
          <div class="field__label" id="sc-topic-label">
            TOPIC
          </div>
          <div class="topics" role="group" aria-labelledby="sc-topic-label">
            {TOPICS.map((t) => (
              <button
                key={t}
                type="button"
                class="topic"
                aria-pressed={t === topic}
                onClick={() => setTopic(t)}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label class="field__label" for="sc-prechat-message">
            MESSAGE
          </label>
          <textarea
            id="sc-prechat-message"
            class="field__textarea"
            placeholder="Describe what happened…"
            value={message}
            onInput={(e) => setMessage(e.currentTarget.value)}
          />
        </div>
      </div>

      <button class="button" type="submit" disabled={sending || !message.trim()}>
        {sending ? 'Starting…' : 'Start conversation'}
      </button>

      {docs.length > 0 && (
        <div class="docs">
          <div class="docs__label">MIGHT ANSWER IT FASTER</div>
          {docs.slice(0, 3).map((doc) => (
            <button
              key={doc.id}
              type="button"
              class="doc"
              onClick={() => onOpenDoc(doc.slug)}
            >
              <span style={{ color: 'var(--sc-tx3)', display: 'flex' }}>
                <DocIcon size={12} />
              </span>
              <span class="doc__title">{doc.title}</span>
            </button>
          ))}
        </div>
      )}
    </form>
  );
}

export default PreChat;
